import { RENDERER_CONFIG } from '@/configs/rendererConfig';
import { ProjectRenderer } from './ProjectRenderer';
import { PointLight, Vector3Tuple, PointLightHelper } from 'three';

const LIGHTS_CONFIG: { position: Vector3Tuple; intensity: number }[] = [
	{ position: [5, 5, 5], intensity: 10 },
	{ position: [-5, 5, 5], intensity: 10 },
	{ position: [5, 5, -5], intensity: 10 },
	{ position: [-5, 5, -5], intensity: 8 },
	{ position: [0, 5, 0], intensity: 5 },
];

export class LightController {
	private lights: PointLight[] = [];

	constructor(private renderer: ProjectRenderer) {
		this.renderer = renderer;
		this.init();
	}

	private init() {
		LIGHTS_CONFIG.forEach((config, idx) => {
			const light = new PointLight(
				RENDERER_CONFIG.LIGHTS_COLOR,
				config.intensity,
				0,
				1
			);
			light.position.set(...config.position);
			light.castShadow = true;
			light.shadow.mapSize.width = 1024;
			light.shadow.mapSize.height = 1024;
			this.renderer.scene.add(light);
			this.lights.push(light);

			if (import.meta.env.PROD) return;

			const helper = new PointLightHelper(light, 1, 0xff0000);
			this.renderer.scene.add(helper);

			const folder = this.renderer.GUI.addFolder(`Lampa ${idx + 1}`);

			folder.add(light.position, 'x', -10, 10).onChange((value) => {
				light.position.x = value;
				helper.position.x = value;
			});
			folder.add(light.position, 'y', -10, 10).onChange((value) => {
				light.position.x = value;
				helper.position.x = value;
			});
			folder.add(light.position, 'z', -10, 10).onChange((value) => {
				light.position.x = value;
				helper.position.x = value;
			});
			folder.add(light, 'intensity', 0, 10).onChange((value) => {});
		});
	}
}
